module.exports = __webpack_public_path__ + "img/powered-by-generac-white.1ca49dd6.svg";